import React, { useRef, useState } from 'react';
import ReportHeader from '../component/report-header/ReportHeader';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import AHMIS, { API_URL } from '../../../api/api';
import { ERROR, REPORT_NOT_DRAWN, SOMETHING_WENT_WRONG, SUCCESS } from '../../../utils/constants';
import AddAlertMessage from '../../../components/alert/Alert';
import MessageBlock from '../../admin/components/message-block/MessageBlock';
import PatientCountCell from '../../../components/patient-count-cell/PatientCountCell';

const StanpaiAamaThaShishuSewaReport = () => {
  const [tableData, setTableData] = useState();
  const printComponentRef = useRef();

  const getReportData = (dateFrom, dateTo) => {
    const url = `${API_URL.stanpaiAamaThaShishuReport}?fromDate=${dateFrom}&toDate=${dateTo}`;
    AHMIS.get(url)
      .then(response => {
        const jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setTableData(jsondata.data);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: `${SOMETHING_WENT_WRONG}: ${error.message}` });
      });
  };

  return (
    <>
      <ReportHeader
        title="स्तनपायी आमा तथा शिशु सेवा प्रतिवेदन"
        getReportData={getReportData}
        reportData={Boolean(tableData)}
        printComponentRef={printComponentRef}
      />
      {tableData ? (
        <Box ref={printComponentRef}>
          <TableContainer classes={{ root: "fixed-head-table-container" }}>
            <Table classes={{ root: "table-bordered normal-spacing" }} size="small">
              <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                <TableRow>
                  <TableCell>विवरण</TableCell>
                  <TableCell>संख्या</TableCell>
                </TableRow>
              </TableHead>
              <TableBody classes={{ root: "align-center" }}>
                <TableRow>
                  <TableCell className="section-header" sx={{ fontWeight: 700 }}>प्रशूति भएको स्थान</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>प्रशूति भएको महिला को संख्या</TableCell>
                  <PatientCountCell data={tableData?.PRASUTI_KO_STHAN?.TOTAL} />
                </TableRow>
                <TableRow>
                  <TableCell>स्वास्थ्य संस्थामा</TableCell>
                  <PatientCountCell data={tableData?.PRASUTI_KO_STHAN?.HEALTH_INSTITUTION} />
                </TableRow>
                <TableRow>
                  <TableCell>घरमा</TableCell>
                  <PatientCountCell data={tableData?.PRASUTI_KO_STHAN?.HOME} />
                </TableRow>
                <TableRow>
                  <TableCell>अन्य</TableCell>
                  <PatientCountCell data={tableData?.PRASUTI_KO_STHAN?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell className="section-header" sx={{ fontWeight: 700 }}>प्रसुति प्रकार</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>सामान्य</TableCell>
                  <PatientCountCell data={tableData?.PRASUTI_KO_TYPES?.NORMAL} />
                </TableRow>
                <TableRow>
                  <TableCell>शल्यक्रिया</TableCell>
                  <PatientCountCell data={tableData?.PRASUTI_KO_TYPES?.CS} />
                </TableRow>
                <TableRow>
                  <TableCell>अन्य</TableCell>
                  <PatientCountCell data={tableData?.PRASUTI_KO_TYPES?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell className="section-header" sx={{ fontWeight: 700 }}>औषधी वितरण</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>शताब्दी १०० ग्राम</TableCell>
                  <PatientCountCell data={tableData?.MEDICINE_DETAILS?.['शताब्दी १०० ग्राम']} />
                </TableRow>
                <TableRow>
                  <TableCell>डासमुल ६० एम एल</TableCell>
                  <PatientCountCell data={tableData?.MEDICINE_DETAILS?.['डासमुल ६० एम एल']} />
                </TableRow>
                <TableRow>
                  <TableCell>जाउनो १०० ग्राम</TableCell>
                  <PatientCountCell data={tableData?.MEDICINE_DETAILS?.['जाउनो १०० ग्राम']} />
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <MessageBlock text={REPORT_NOT_DRAWN} />
      )}
    </>
  );
};

export default StanpaiAamaThaShishuSewaReport;
